import React from 'react'

interface ISpinnerProps {
  size?: 'small' | 'default' | 'large'
  variant?: 'default' | 'primary' | 'success' | 'error'
}

const Spinner: React.FC<ISpinnerProps> = ({
  size = 'default',
  variant = 'default'
}) => <div className={`spinner spinner-${size} spinner-${variant}`} />

export default Spinner
